import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

type Props = {}

export default function RptAEO({}: Props) {  
    const navigate = useNavigate();

    useEffect(() => {
          window.open("https://aeo.gemcousa.online/", "_blank", "noopener,noreferrer");
           return navigate("/", { replace: true }); ; 
    }, [])

  return (
    < >
    </>
  );
}